// import React from 'react'
// import  { useState } from 'react';


// export const Page = () => {
//     // Define CSS styles in an object
// const styles = {
//     container: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       height: '100vh',
//       background: '#f2f2f2',
//       fontFamily: 'Arial, sans-serif',
//     },
//     title: {
//       fontSize: '3rem',
//       fontWeight: 'bold',
//       color: '#333',
//       marginBottom: '1rem',
//     },
//     button: {
//       padding: '1rem 2rem',
//       borderRadius: '2rem',
//       background: '#4CAF50',
//       color: 'white',
//       fontSize: '1.5rem',
//       border: 'none',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//     },
//     buttonHover: {
//       background: '#3e8e41',
//     },
//     message: {
//       fontSize: '2rem',
//       color: '#f44336',
//       marginTop: '2rem',
//     },
//   };
//     const [message, setMessage] = useState('');

//     function handleClick() {
//         setMessage("Sorry couldn't give it to you.\n Please try again later!!");
      

//     }
  
//     return (
//       <div style={styles.container}>
//         <h1 style={styles.title}>Ask For It</h1>
//         <button
//           style={{ ...styles.button, ...(message && styles.buttonHover) }}
//           onClick={handleClick}
//         >
//           Ask For It
//         </button>
//         {/* {message && <p style={styles.message}>{message}
//         </p>} */}
//         <p style={styles.message}>
//         {message && message.split('\n').map((line, index) => (
//         <React.Fragment key={index}>
//           {line}
//           <br />
//         </React.Fragment>
//       ))}
//         </p>
//       </div>
//     );
// }

import React from 'react'
import  { useState } from 'react';


export const Page = () => {
// Define CSS styles in an object
const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#f2f2f2',
      fontFamily: 'Arial, sans-serif',
    },
    title: {
      fontSize: '3rem',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '1rem',
    },
    button: {
      padding: '1rem 2rem',
      borderRadius: '2rem',
      background: '#4CAF50',
      color: 'white',
      fontSize: '1.5rem',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    buttonHover: {
      background: '#3e8e41',
    },
    message: {
      fontSize: '2rem',
      color: '#f44336',
      marginTop: '2rem',
    },
  };
  const messageTypes = [
    "Sorry couldn't give it to you.",
    "We're all out, try again later.",
    "I'm afraid that's not possible.",
    "You're asking for the moon!",
    "Maybe next time.",
  ];

  const [message, setMessage] = useState('');

  function handleClick() {
    const randomIndex = Math.floor(Math.random() * messageTypes.length);
    setMessage(messageTypes[randomIndex]);
  }
  
    return (
        <div style={styles.container}>
        <h1 style={styles.title}>Ask For It</h1>
        <button
          style={{ ...styles.button, ...(message && styles.buttonHover) }}
          onClick={handleClick}
        >
          Ask For It
        </button>
        <p style={styles.message}>
          {message && message.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
      </div>
    );
}
